import { render, staticRenderFns } from "./Annkenn.vue?vue&type=template&id=88d12fa2&scoped=true&"
import script from "./Annkenn.vue?vue&type=script&lang=ts&"
export * from "./Annkenn.vue?vue&type=script&lang=ts&"
import style0 from "./Annkenn.vue?vue&type=style&index=0&id=88d12fa2&lang=scss&scoped=true&"
import style1 from "./Annkenn.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d12fa2",
  null
  
)

export default component.exports